import {
    MgdRoutes,
    IAppOptions
} from "@shopliftr/common-ng";
import { AppRouteId } from "./common/enums/app-route-id.enum";
import { DESIGNER_FEATURE_GROUP_ID } from "./designer/constants/designer-feature-group-id";
import { PROOFS_PAGES_FEATURE_GROUP_ID } from "./proofs-pages/constants/proofs-pages-feature-group-id.constant";
import { REPORTING_FEATURE_GROUP_ID } from "./reporting/constants/reporting-constants";
import { IAppConfig } from "./common/interfaces/app-config";
import { environment } from "../environments/environment";
import { APP_CONFIG } from "./common/constants/app-config-token";
import { AppRouterService } from "./common/services/app-router.service";
import { AppService } from "./common/services/app.service";

/**
 * These are the routes for the application.
 *
 * They are bootstrapped in the APP_OPTIONS.routes field
 */
const APP_ROUTES: MgdRoutes = [
    {
        path: "",
        redirectTo: "designer",
        pathMatch: "full"
    },
    {
        path: "designer",
        data: {
            breadcrumb: "Designer",
            routeId: AppRouteId.Designer,
            childFeatureGroupId: DESIGNER_FEATURE_GROUP_ID,
            sidenavLink: {
                icon: "architecture",
                title: "Designer",
                tooltip: "Display Campaign Designer",
                permissions: ["campaign-read"]
            }
        },
        loadChildren: () => import("./designer/designer.feature-group").then((f) => f.ROUTES)
    },
    {
        path: "reporting",
        data: {
            routeId: AppRouteId.Reporting,
            childFeatureGroupId: REPORTING_FEATURE_GROUP_ID,
            breadcrumb: "Reporting",
            sidenavLink: {
                icon: "grid_on",
                title: "Reporting",
                tooltip: "Campaign Reports",
                permissions: ["campaign-read"]
            }
        },
        loadChildren: () => import("./reporting/reporting.feature-group").then((f) => f.ROUTES)
    },
    {
        path: "proofs-pages",
        data: {
            routeId: AppRouteId.ProofsPages,
            childFeatureGroupId: PROOFS_PAGES_FEATURE_GROUP_ID,
            breadcrumb: "Proofs Pages",
            sidenavLink: {
                icon: "fact_check",
                title: "Proofs Pages",
                tooltip: "Proofs Pages",
                permissions: ["campaign-read"]
            }
        },
        loadChildren: () => import("./proofs-pages/proofs-pages.feature-group").then((f) => f.ROUTES)
    }
];

/**
 * These are the options used to bootstrap the application
 */
export const APP_OPTIONS: IAppOptions<IAppConfig> = {

    config: environment,
    configInjectionToken: APP_CONFIG,
    appRouterService: AppRouterService,
    appService: AppService,
    routes: APP_ROUTES,
    useLocalizations: true
};
